/*
 * Public API Surface of microapp-facilitiesbooking
 */

export * from './lib/microapp-facilitiesbooking.service';
export * from './lib/microapp-facilitiesbooking.module';
export * from './pages/microapp-facilitiesbooking.facilitybooking.component';
export * from './pages/microapp-facilitiesbooking.facilitybooking.module';
